import { useMemo } from 'react';

import { ICD10Disease } from '@dreryk/egabinet-icd-dictionary-frontend-api';

import { useInteractiveTableContext } from '@dreryk/react-components';

import { DiagnosesTableBean } from '../table/DiagnosesInteractiveTable.types';

export const useDefaultItems = (defaultItems: ICD10Disease[] | undefined): ICD10Disease[] => {
   const { getValues } = useInteractiveTableContext<DiagnosesTableBean>();

   return useMemo((): ICD10Disease[] => {
      if (!defaultItems?.length) {
         return [];
      }

      const selectedDiagnosesCodesSet = new Set(getValues().map((diagnoses) => diagnoses.code));

      return defaultItems.filter((suggestion) => {
         return !selectedDiagnosesCodesSet.has(suggestion.code);
      });
   }, [defaultItems, getValues]);
};
